import React from 'react';
import Events from './Events';
import ParentLayout from './ParentLayout';

export default function Layout(props) {
  return (
    <ParentLayout title="Events">
      {function(params) {
        return (
          <>
            <Events params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
